module.exports = __webpack_public_path__ + "static/media/success.6c0f4c3f.png";